<script setup lang="ts">
import type { ContentBlock } from '~/types'

const { fetchData } = useLoadConfiguration()
const { data } = await useAsyncData('configuration', () => fetchData())
const currentEntity = useCurrentEntity()

const contentBlocks = computed<ContentBlock.Model[]>(() => data.value?.homepageContentBlocks || [])

currentEntity.value = {
  title: 'Home Page',
  dashboardUrl: 'nova-settings/homepage',
  type: 'homePage',
}
</script>

<template>
  <div>
    <UIDynamicHeading
      as="h1"
      level="1"
      class="sr-only"
    >
      The UFL Home Page
    </UIDynamicHeading>
    <Page
      :content-blocks
      class="homepage"
    />
  </div>
</template>
